import { rankingData } from '@/mocks/homeData';

export default function RankingSection() {
  const getRankStyle = (rank: number) => {
    if (rank === 1) return 'bg-primary-500 text-background-50';
    if (rank === 2) return 'bg-primary-400 text-background-50';
    if (rank === 3) return 'bg-accent-500 text-background-50';
    return 'bg-background-200 text-foreground-600';
  };

  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-950 font-heading">{rankingData.title}</h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">{rankingData.subtitle}</p>
        </div>
        <div className="max-w-2xl mx-auto bg-background-100 rounded-xl border border-background-200/70 overflow-hidden">
          {rankingData.items.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-4 p-4 md:p-5 ${
                i < rankingData.items.length - 1 ? 'border-b border-background-200/60' : ''
              } cursor-pointer hover:bg-background-50 transition-colors`}
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-extrabold flex-shrink-0 ${getRankStyle(item.rank)}`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 hover:text-primary-500 transition-colors truncate">{item.title}</h3>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-xs text-foreground-500 whitespace-nowrap">{item.heat}</span>
                <span className={`w-5 h-5 flex items-center justify-center rounded`}>
                  <i className={`text-sm ${
                    item.trend === 'up' ? 'ri-arrow-up-line text-primary-500' :
                    item.trend === 'down' ? 'ri-arrow-down-line text-foreground-400' :
                    'ri-add-line text-accent-500'
                  }`}></i>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}